import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the SearchPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'searchnakshatra',
})
export class SearchNakshatraPipe implements PipeTransform {
    /**
     * Takes a value and makes it lowercase.
     */
    // transform(value: string, ...args) {
    //   return value.toLowerCase();
    // }
    
    // transform(items: any[], nakshatra: string): any[] {
    //   if(!items) return [];
    //   if(!nakshatra) return items;
    //   nakshatra = nakshatra.toLowerCase();
    //   return items.filter( it => {
    //     return it.nakshatra.toLowerCase().includes(nakshatra); // only filter country name
    //   });
    // }
    transform(items: any, nakshatra: any): any {
      if (nakshatra) {
          nakshatra = nakshatra.toLowerCase();
          return items.filter(item => {
              return Object.keys(item).some(
                  k => {
                      if (item[k] != null && item[k] != undefined && typeof item[k] == 'string')
                           return item[k].toLowerCase().startsWith(nakshatra);
                        //return item[k].includes(nakshatra);
                  }
              );
          });
      }
      return items;
    }
    // transform(items: any, nakshatra: any): any {
    //     if (nakshatra) {
    //         return items.filter((item) => {
    //             return item.name.toLowerCase().includes(nakshatra.toLowerCase());
    //         });  
    //     }
    //     return items;
    //   }
    // transform(items: any[], nakshatra: string): any[] {
    //     if(!items) return [];
    //     if(!nakshatra) return items;
    // nakshatra = nakshatra.toLowerCase();
    // return items.filter( it => {
    //       return it.includes(nakshatra);
    //     });
    //    }
  }


// WEBPACK FOOTER //
// ./src/pipes/search/searchnakshatra.ts